import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/sunpay/step1.png'
import _imports_1 from '@/assets/images/annex/step1.png'
import _imports_2 from '@/assets/images/annex/step2.png'
import _imports_3 from '@/assets/images/sunpay/step3.png'
import _imports_4 from '@/assets/images/annex/step4.png'
import _imports_5 from '@/assets/images/annex/status/0.png'
import _imports_6 from '@/assets/images/icon-copy.png'
import _imports_7 from '@/assets/images/annex/status/1.png'
import _imports_8 from '@/assets/images/annex/status/3.png'
import _imports_9 from '@/assets/images/annex/status/2.png'


_pushScopeId("data-v-efb938b4")
const _hoisted_1 = { class: "solt" }
const _hoisted_2 = {
  key: 0,
  class: "steps"
}
const _hoisted_3 = { class: "head" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "step1"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: "step1"
}
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "totals font-bold" }
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "body" }
const _hoisted_12 = { class: "icons" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "coin" }
const _hoisted_18 = { class: "cname font-bold" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "title"
}
const _hoisted_22 = { class: "icons" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "name" }
const _hoisted_25 = { class: "font-bold" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "value" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1)
const _hoisted_27 = { class: "footer" }
const _hoisted_28 = { class: "desc" }
const _hoisted_29 = {
  key: 0,
  class: "total font-bold"
}
const _hoisted_30 = { class: "number" }
const _hoisted_31 = { class: "action" }
const _hoisted_32 = {
  key: 1,
  class: "steps fill"
}
const _hoisted_33 = { class: "head" }
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "icon" }
const _hoisted_36 = {
  key: 0,
  src: _imports_0,
  alt: "step1"
}
const _hoisted_37 = {
  key: 1,
  src: _imports_2,
  alt: "step2"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "time" }, null, -1)
const _hoisted_39 = { class: "body" }
const _hoisted_40 = {
  key: 0,
  class: "form"
}
const _hoisted_41 = { class: "label required" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "footer" }
const _hoisted_44 = { class: "action" }
const _hoisted_45 = { class: "head" }
const _hoisted_46 = { class: "title" }
const _hoisted_47 = { class: "icon" }
const _hoisted_48 = {
  key: 0,
  src: _imports_3,
  alt: "step3"
}
const _hoisted_49 = {
  key: 1,
  src: _imports_4,
  alt: "step4"
}
const _hoisted_50 = { class: "time" }
const _hoisted_51 = { class: "block" }
const _hoisted_52 = { class: "block" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "colon" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1)
const _hoisted_54 = { class: "block" }
const _hoisted_55 = { class: "block" }
const _hoisted_56 = { class: "body" }
const _hoisted_57 = {
  key: 0,
  class: "icon"
}
const _hoisted_58 = { class: "text" }
const _hoisted_59 = { class: "qrcode" }
const _hoisted_60 = { class: "icon" }
const _hoisted_61 = ["src", "alt"]
const _hoisted_62 = { class: "font-bold" }
const _hoisted_63 = { class: "p" }
const _hoisted_64 = { class: "tip" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_66 = { class: "pending" }
const _hoisted_67 = { class: "line" }
const _hoisted_68 = { class: "label" }
const _hoisted_69 = { class: "value" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "copy"
}, null, -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "text" }
const _hoisted_74 = { class: "qrcode" }
const _hoisted_75 = { class: "icon" }
const _hoisted_76 = ["src", "alt"]
const _hoisted_77 = { class: "font-bold" }
const _hoisted_78 = { class: "p" }
const _hoisted_79 = { class: "subtitle" }
const _hoisted_80 = { class: "paycode" }
const _hoisted_81 = { class: "input border" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "copy"
}, null, -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "status"
}, null, -1)
const _hoisted_85 = { class: "font-bold" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = {
  key: 3,
  class: "payment-type"
}
const _hoisted_89 = {
  key: 1,
  class: "icon"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1)
const _hoisted_91 = { class: "success" }
const _hoisted_92 = {
  key: 2,
  class: "icon"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1)
const _hoisted_94 = { class: "fail" }
const _hoisted_95 = {
  key: 3,
  class: "icon"
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1)
const _hoisted_97 = { class: "cancel" }
const _hoisted_98 = { class: "footer" }
const _hoisted_99 = { class: "action" }
_popScopeId()

export function render(_ctx: any,_cache: any) {
  const _component_Types = _resolveComponent("Types")!
  const _component_KP_INPUT = _resolveComponent("KP_INPUT")!
  const _component_KP_SELECT = _resolveComponent("KP_SELECT")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.steps == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", _hoisted_7))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("defray.choose")), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "times", {}, undefined, true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("defray.total")), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.result?.amount) + " " + _toDisplayString(_ctx.result?.currency), 1)
          ]),
          _createVNode(_component_Types, {
            modelValue: _ctx.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.type = $event)),
            showCrypto: _ctx.showCrypto,
            "onUpdate:showCrypto": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCrypto = $event)),
            showFiat: _ctx.showFiat,
            "onUpdate:showFiat": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFiat = $event))
          }, null, 8, ["modelValue", "showCrypto", "showFiat"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass(["project", { f2: _ctx.result?.cash_currency_config_list?.length > 2 }])
            }, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result?.cash_currency_config_list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["item", { active: item.currency == _ctx.checkCurrency.currency }]),
                    key: item.currency,
                    onClick: ($event: any) => (_ctx.setCheckCurrency(item))
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: item.web_icon,
                          alt: item.currency
                        }, null, 8, _hoisted_16)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(item.currency), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode(_toDisplayString(item.amount) + " ", 1),
                      _hoisted_20
                    ])
                  ], 10, _hoisted_13))
                }), 128))
              ])
            ], 2),
            (_ctx.checkCurrency?.payment_type_list?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("defray.paymentType")), 1))
              : _createCommentVNode("", true),
            (_ctx.checkCurrency?.payment_type_list?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["project", { f2: _ctx.checkCurrency?.payment_type_list?.length > 2 }])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkCurrency?.payment_type_list, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["item", { active: item == _ctx.checkPaymentType }]),
                        key: index,
                        onClick: ($event: any) => (_ctx.setcheckPaymentType(item))
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item), 1)
                        ]),
                        _hoisted_26
                      ], 10, _hoisted_23))
                    }), 128))
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("defray.remark", {
              brand: ["sunpaysandbox", "sunpayprod"].includes(_ctx.dev) ? "Sun Pay" : "Klickl Pay"
            })), 1),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("defray.total")), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.result?.amount) + " " + _toDisplayString(_ctx.result?.currency), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_31, [
              (_ctx.result?.cancel_url)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "button gery",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelPayment && _ctx.cancelPayment(...args)))
                  }, _toDisplayString(_ctx.$t("defray.cancel")), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "button dark",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
              }, _toDisplayString(_ctx.$t("next")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.steps == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                  : (_openBlock(), _createElementBlock("img", _hoisted_37))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("defray.fill")), 1)
            ]),
            _hoisted_38
          ]),
          _createElementVNode("div", _hoisted_39, [
            (_ctx.dynamicsFiledList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicsFiledList, (field, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item full",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.resverText(field["field_name"])) + "：", 1),
                      _createElementVNode("div", _hoisted_42, [
                        (field['type'] == 'text')
                          ? (_openBlock(), _createBlock(_component_KP_INPUT, {
                              key: 0,
                              type: 'text',
                              modelValue: _ctx.FormData[field.field_name],
                              "onUpdate:modelValue": ($event: any) => (_ctx.FormData[field.field_name] = $event),
                              expand: field['expand'],
                              placeholder: field['field_name']
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "expand", "placeholder"]))
                          : _createCommentVNode("", true),
                        (field['type'] == 'select')
                          ? (_openBlock(), _createBlock(_component_KP_SELECT, {
                              key: 1,
                              index: 0,
                              modelValue: _ctx.FormData[field.field_name],
                              "onUpdate:modelValue": ($event: any) => (_ctx.FormData[field.field_name] = $event),
                              "field-name": field['field_name'],
                              list: field['value'],
                              onChange: _ctx.onSelectChange
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "field-name", "list", "onChange"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", {
                class: "button",
                onClick: _cache[5] || (_cache[5] = 
              () => {
                _ctx.steps--;
              }
            )
              }, _toDisplayString(_ctx.$t("back")), 1),
              _createElementVNode("div", {
                class: "button dark",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createOrder && _ctx.createOrder(...args)))
              }, _toDisplayString(_ctx.$t("defray.pay")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.steps == 3)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["steps result status", _ctx.result?.extend?.order_status == 'PENDING' ? 'loader' : ''])
        }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_48))
                  : (_openBlock(), _createElementBlock("img", _hoisted_49))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("defray.status.title")), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              (_ctx.result?.extend?.order_status == 'PENDING')
                ? (_openBlock(), _createBlock(_component_van_count_down, {
                    key: 0,
                    time: Number(_ctx.result?.extend?.expires_in) * 1000,
                    format: "mm:ss",
                    onFinish: _ctx.finish
                  }, {
                    default: _withCtx((timeData) => [
                      _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.SplitNumber(timeData.minutes)[0]), 1),
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.SplitNumber(timeData.minutes)[1]), 1),
                      _hoisted_53,
                      _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.SplitNumber(timeData.seconds)[0]), 1),
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.SplitNumber(timeData.seconds)[1]), 1)
                    ]),
                    _: 1
                  }, 8, ["time", "onFinish"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            (_ctx.result?.extend?.order_status == 'PENDING')
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  (_ctx.result?.extend?.action_type == 'QRCODE')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("defray.scan")), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_VueQrcode, {
                            value: _ctx.result?.extend?.qr_code,
                            tag: "img",
                            options: {
                  width: 160,
                  margin: 0
                }
                          }, null, 8, ["value"]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("img", {
                              src: _ctx.result?.extend?.web_icon,
                              alt: _ctx.result?.extend?.currency
                            }, null, 8, _hoisted_61)
                          ]),
                          _createElementVNode("h4", _hoisted_62, [
                            _createTextVNode(_toDisplayString(_ctx.$t("defray.pay")) + " ", 1),
                            _createElementVNode("em", null, _toDisplayString(_ctx.result?.extend?.amount) + " " + _toDisplayString(_ctx.result?.extend?.currency), 1)
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("defray.scanTip", { name: _ctx.result?.extend?.account_type })), 1)
                          ])
                        ])
                      ], 64))
                    : (_ctx.result?.extend?.action_type == 'CODE')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.isCanSerialize(_ctx.result?.extend?.payment_code))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_65,
                                _createElementVNode("h3", _hoisted_66, _toDisplayString(_ctx.$t("defray.status.pending.title")), 1),
                                _createElementVNode("div", _hoisted_67, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("defray.dynamic.payToAccount")), 1)
                                ]),
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.result?.extend?.payment_code), (val, key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      val
                                        ? (_openBlock(), _createElementBlock("li", { key: key }, [
                                            _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t(`defray.dynamic.${key}`) || _ctx.resverText(key)), 1),
                                            _createElementVNode("div", _hoisted_69, [
                                              _createTextVNode(_toDisplayString(val) + " ", 1),
                                              _createElementVNode("div", {
                                                class: "extend",
                                                onClick: ($event: any) => (_ctx.copy(val))
                                              }, _hoisted_72, 8, _hoisted_70)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256))
                                ])
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t("defray.scan")), 1),
                                _createElementVNode("div", _hoisted_74, [
                                  _createVNode(_component_VueQrcode, {
                                    value: _ctx.result?.extend?.payment_code || _ctx.result?.extend?.va_number,
                                    tag: "img",
                                    options: {
                    width: 160,
                    margin: 0
                  }
                                  }, null, 8, ["value"]),
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("img", {
                                      src: _ctx.result?.extend?.web_icon,
                                      alt: _ctx.result?.extend?.currency
                                    }, null, 8, _hoisted_76)
                                  ]),
                                  _createElementVNode("h4", _hoisted_77, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("defray.pay")) + " ", 1),
                                    _createElementVNode("em", null, _toDisplayString(_ctx.result?.extend?.amount) + " " + _toDisplayString(_ctx.result?.extend?.currency), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_78, [
                                    _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.$t("defray.paymentCode")) + ":", 1),
                                    _createElementVNode("div", _hoisted_80, [
                                      _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.result?.extend?.payment_code || _ctx.result?.extend?.va_number), 1),
                                      _createElementVNode("div", {
                                        class: "extend border",
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.copy(_ctx.result?.extend?.payment_code || _ctx.result?.extend?.va_number)))
                                      }, _hoisted_83)
                                    ])
                                  ])
                                ])
                              ], 64))
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _hoisted_84,
                          _createElementVNode("h4", _hoisted_85, [
                            _createTextVNode(_toDisplayString(_ctx.$t("defray.pay")) + " ", 1),
                            _createElementVNode("em", null, _toDisplayString(_ctx.result?.extend?.amount) + " " + _toDisplayString(_ctx.result?.extend?.currency), 1)
                          ]),
                          (_ctx.result?.extend?.account_type == 'MOMO')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.$t("defray.momo")), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(_ctx.$t("defray.status.pending.desc")), 1))
                        ], 64)),
                  (_ctx.result?.extend?.account_type)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_ctx.result?.extend?.account_type), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.result?.extend?.order_status == 'SUCCESS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                  _hoisted_90,
                  _createElementVNode("h3", _hoisted_91, _toDisplayString(_ctx.$t("defray.status.success.title")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.status.success.desc")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.result?.extend?.order_status == 'FAIL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  _hoisted_93,
                  _createElementVNode("h3", _hoisted_94, _toDisplayString(_ctx.$t("defray.status.fail.title")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.status.fail.desc")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.result?.extend?.order_status == 'CANCEL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _hoisted_96,
                  _createElementVNode("h3", _hoisted_97, _toDisplayString(_ctx.$t("defray.status.cancel.title")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.status.cancel.desc")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              (_ctx.result?.cancel_url && ['PENDING'].includes(_ctx.result?.extend?.order_status))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "button dark",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelPayment && _ctx.cancelPayment(...args)))
                  }, _toDisplayString(_ctx.$t("defray.cancel")), 1))
                : _createCommentVNode("", true),
              (
              ['PENDING'].includes(_ctx.result?.extend?.order_status) &&
                _ctx.result?.extend?.action_type == 'REDIRECT'
            )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "button blue",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toPayment && _ctx.toPayment(...args)))
                  }, _toDisplayString(_ctx.$t("defray.toPay")), 1))
                : _createCommentVNode("", true),
              (
              ['CANCEL', 'FAIL', 'SUCCESS'].includes(_ctx.result?.extend?.order_status) &&
                _ctx.result?.redirect_url
            )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "button blue",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args)))
                  }, _toDisplayString(_ctx.$t("complete")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}